/*eslint-disable*/
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import logo from "assets/img/Logo-ciel.jpg";
import UserDropdown from "components/Dropdowns/UserDropdown";
import UserService from "services/user.service";
import { IUser } from "models/church.types";
import { hasAnyAuthority, ROLES } from "services/security.utils";

export default function Sidebar() {
  const [currentUser, setCurrentUser] = useState<IUser | null>(null);
  const [loadingUser, setLoadingUser] = useState(true);
  // On repasse à un état simple
  const [collapseShow, setCollapseShow] = React.useState("hidden");

  const [openStructure, setOpenStructure] = React.useState(true);
  const [openActivities, setOpenActivities] = React.useState(false);
  const [openFinance, setOpenFinance] = React.useState(false);
  const [openContributions, setOpenContributions] = useState(false);

  const hasRole = (role) => currentUser?.authorities?.includes(role);
  const closeMenu = () => setCollapseShow("hidden");

  useEffect(() => {
    // Récupération des infos utilisateur au chargement
    UserService.getCurrentAccount()
      .then((res) => setCurrentUser(res.data))
      .catch(() => console.error("Erreur chargement profil"))
      .finally(() => setLoadingUser(false));
  }, []);

  const isFinanceAuthorized = hasAnyAuthority(currentUser?.authorities, [
    ROLES.ADMIN,
    ROLES.PASTEUR,
    ROLES.TRESORERIE,
  ]);

  return (
    <>
      <nav className="md:left-0 bg-[#0F172A] border-r border-slate-700 md:block md:fixed md:top-0 md:bottom-0 md:overflow-y-auto md:flex-row md:flex-nowrap md:overflow-hidden shadow-xl flex flex-wrap items-center justify-between relative md:w-64 z-50 py-4 px-6">
        {" "}
        <div className="md:flex-col md:items-stretch md:min-h-full md:flex-nowrap px-0 flex flex-wrap items-center justify-between w-full mx-auto">
          {/* --- BLOC MOBILE UNIQUEMENT (Hamburger + Dropdown Profil) --- */}
          <div className="flex items-center md:hidden">
            {/* 1. Bouton Profil Mobile (à gauche ou à droite du hamburger) */}
            <ul className="flex-col md:flex-row list-none items-center flex">
              <UserDropdown />
            </ul>

            {/* 2. Toggler Hamburger */}
            <button
              className="cursor-pointer text-white opacity-80 px-3 py-1 text-xl leading-none bg-transparent rounded border border-solid border-transparent ml-2"
              type="button"
              onClick={() => setCollapseShow("bg-[#1E293B] m-0 py-3 px-6")}
            >
              <i className="fas fa-bars"></i>
            </button>
          </div>

          {/* Logo (Visible sur les deux, centré sur mobile) */}
          <Link
            className="md:block text-left md:pb-6 text-white mr-0 inline-block whitespace-nowrap text-sm uppercase font-bold p-4 px-0"
            to="/"
          >
            <div className="flex items-center">
              <img
                src={logo}
                alt="Logo"
                className="w-16 h-16 mr-4 object-contain rounded-full border-2 border-slate-700"
              />
              <span className="tracking-wider text-[#D4AF37] text-base font-extrabold">
                CIEL
              </span>
            </div>
          </Link>

          {/* Menu de navigation (Collapse) */}
            <div
              className={
                "md:flex md:flex-col md:items-stretch md:opacity-100 md:relative md:mt-4 " +
                "md:shadow-none " +
                "shadow-xl absolute top-0 left-0 right-0 z-[9999] " +
                "overflow-y-auto overflow-x-hidden " +
                "h-screen min-h-screen " +
                "items-center flex-1 rounded-none " +
                collapseShow
              }
            >
            {/* Header du Collapse Mobile (Titre + Bouton Fermer) */}
            <div className="md:min-w-full md:hidden block pb-4 mb-4 border-b border-solid border-slate-700">
              <div className="flex flex-wrap items-center">
                <div className="w-6/12">
                  <span className="text-[#D4AF37] font-bold uppercase text-xs">
                    Menu
                  </span>
                </div>
                <div className="w-6/12 flex justify-end">
                  <button
                    type="button"
                    className="cursor-pointer text-white opacity-70 px-3 py-1 text-xl"
                    onClick={() => setCollapseShow("hidden")}
                  >
                    <i className="fas fa-times"></i>
                  </button>
                </div>
              </div>
            </div>

            {/* Menu Links */}
            <ul className="md:flex-col md:min-w-full flex flex-col list-none">
              <li className="items-center">
                <Link
                  className={
                    "text-xs uppercase py-3 font-bold block " +
                    (window.location.pathname.includes("/admin/dashboard")
                      ? "text-[#D4AF37]"
                      : "text-white")
                  }
                  to="/admin/dashboard"
                  onClick={closeMenu}
                >
                  <i className="fas fa-tv mr-2 text-sm opacity-75"></i> Tableau
                  de bord
                </Link>
              </li>

              {/* Structure */}
              <li className="items-center">
                <div
                  className="text-slate-400 text-xs uppercase py-3 font-bold block cursor-pointer hover:text-white flex justify-between items-center"
                  onClick={() => setOpenStructure(!openStructure)}
                >
                  <span>
                    <i className="fas fa-church mr-2"></i> Structure
                  </span>
                  <i
                    className={`fas ${openStructure ? "fa-chevron-down" : "fa-chevron-right"} text-[10px]`}
                  ></i>
                </div>
                <ul
                  className={`flex-col list-none pl-4 ${openStructure ? "flex" : "hidden"}`}
                >
                  <li>
                    <Link
                      className="text-xs py-2 font-semibold block text-slate-300 hover:text-[#D4AF37]"
                      to="/admin/departments"
                      onClick={closeMenu}
                    >
                      Départements
                    </Link>
                  </li>
                  {/* Lien Écodime */}
                  <li>
                    <Link
                      className="text-xs py-2 font-semibold block text-slate-300 hover:text-[#D4AF37]"
                      to="/admin/ecodime-classes"
                      onClick={closeMenu}
                    >
                      Classes Écodime
                    </Link>
                  </li>
                  <li>
                    <Link
                      className="text-xs py-2 font-semibold block text-slate-300 hover:text-[#D4AF37]"
                      to="/admin/members"
                      onClick={closeMenu}
                    >
                      Membres
                    </Link>
                  </li>
                </ul>
              </li>

              {/* Evenement */}
              <li className="items-center mt-2">
                <div
                  className="text-slate-400 text-xs uppercase py-3 font-bold block cursor-pointer hover:text-white flex justify-between items-center"
                  onClick={() => setOpenActivities(!openActivities)}
                >
                  <span>
                    <i className="fas fa-calendar-check mr-2"></i> Evénements
                  </span>
                  <i
                    className={`fas ${openActivities ? "fa-chevron-down" : "fa-chevron-right"} text-[10px]`}
                  ></i>
                </div>
                <ul
                  className={`flex-col list-none pl-4 ${openActivities ? "flex" : "hidden"}`}
                >
                  <li>
                    <Link
                      className="text-xs py-2 font-semibold block text-slate-300 hover:text-[#D4AF37]"
                      to="/admin/event-types"
                      onClick={closeMenu}
                    >
                      Types d'événements
                    </Link>
                  </li>
                  <li>
                    <Link
                      className="text-xs py-2 font-semibold block text-slate-300 hover:text-[#D4AF37]"
                      to="/admin/events"
                      onClick={closeMenu}
                    >
                      Événements
                    </Link>
                  </li>
                  <li>
                    <Link
                      className="text-xs py-2 font-semibold block text-slate-300 hover:text-[#D4AF37]"
                      to="/admin/attendances"
                      onClick={closeMenu}
                    >
                      Présences
                    </Link>
                  </li>
                  {/* Ajout de la gestion des formations */}
                  <li>
                    <Link
                      className={
                        "text-xs py-2 font-semibold block transition-colors " +
                        (window.location.pathname.includes("/admin/trainings")
                          ? "text-[#D4AF37]"
                          : "text-slate-300 hover:text-[#D4AF37]")
                      }
                      to="/admin/trainings"
                      onClick={closeMenu}
                    >
                      Formations
                    </Link>
                  </li>
                  {/* Suivi des formations (MemberTraining) */}
                  <li>
                    <Link
                      className={
                        "text-xs py-2 font-semibold block transition-colors " +
                        (window.location.pathname.includes(
                          "/admin/member-trainings",
                        )
                          ? "text-[#D4AF37]"
                          : "text-slate-300 hover:text-[#D4AF37]")
                      }
                      to="/admin/member-trainings"
                      onClick={closeMenu}
                    >
                      Suivi des formations
                    </Link>
                  </li>
                </ul>
              </li>

              {/* Finance / Trésorerie (Sécurisé) */}
              {isFinanceAuthorized && (
              <li className="items-center mt-2">
                <div
                  className="text-slate-400 text-xs uppercase py-3 font-bold block cursor-pointer hover:text-white flex justify-between items-center"
                  onClick={() => setOpenFinance(!openFinance)}
                >
                  <span>
                    <i className="fas fa-wallet mr-2"></i> Trésorerie
                  </span>
                  <i
                    className={`fas ${openFinance ? "fa-chevron-down" : "fa-chevron-right"} text-[10px]`}
                  ></i>
                </div>
                <ul
                  className={`flex-col list-none pl-4 ${openFinance ? "flex" : "hidden"}`}
                >
                  <li>
                    <Link
                      className="text-xs py-2 font-semibold block text-slate-300 hover:text-[#D4AF37]"
                      to="/admin/offerings"
                      onClick={closeMenu}
                    >
                      <i className="fas fa-hand-holding-usd mr-2 w-4 text-center"></i>{" "}
                      Offrandes
                    </Link>
                  </li>
                  <li>
                    <Link
                      className="text-xs py-2 font-semibold block text-slate-300 hover:text-[#D4AF37]"
                      to="/admin/tithes"
                      onClick={closeMenu}
                    >
                      <i className="fas fa-donate mr-2 w-4 text-center"></i>{" "}
                      Dîmes
                    </Link>
                  </li>
                  <li>
                    <Link
                      className="text-xs py-2 font-semibold block text-slate-300 hover:text-[#D4AF37]"
                      to="/admin/expenses"
                      onClick={closeMenu}
                    >
                      <i className="fas fa-file-invoice-dollar mr-2 w-4 text-center"></i>{" "}
                      Dépenses
                    </Link>
                  </li>
                </ul>
              </li>
              )}

               {/* Contributions & Engagements (Accessible à tous) */}
              <li className="items-center mt-2">
                <div
                  className="text-slate-400 text-xs uppercase py-3 font-bold block cursor-pointer hover:text-white flex justify-between items-center"
                  onClick={() => setOpenContributions(!openContributions)} // Pensez à déclarer ce useState en haut s'il n'existe pas
                >
                  <span>
                    <i className="fas fa-hand-holding-heart mr-2"></i>{" "}
                    Contributions
                  </span>
                  <i
                    className={`fas ${openContributions ? "fa-chevron-down" : "fa-chevron-right"} text-[10px]`}
                  ></i>
                </div>
                <ul
                  className={`flex-col list-none pl-4 ${openContributions ? "flex" : "hidden"}`}
                >
                  <li>
                    <Link
                      className="text-xs py-2 font-semibold block text-slate-300 hover:text-[#D4AF37]"
                      to="/admin/contributions"
                      onClick={closeMenu}
                    >
                      <i className="fas fa-heart mr-2 w-4 text-center"></i>{" "}
                      Liste des Contributions
                    </Link>
                  </li>
                  <li>
                    <Link
                      className="text-xs py-2 font-semibold block text-slate-300 hover:text-[#D4AF37]"
                      to="/admin/contribution-types"
                      onClick={closeMenu}
                    >
                      <i className="fas fa-coins mr-2 w-4 text-center"></i>{" "}
                      Types de contribution
                    </Link>
                  </li>
                </ul>
              </li>

              {/* Admin */}
              {hasRole("ROLE_ADMIN") && (
                <li className="items-center mt-4 border-t border-slate-700 pt-4">
                  {/* Gestion des Utilisateurs */}
                  <Link
                    className="text-xs py-2 font-bold block text-white hover:text-slate-300 transition-colors"
                    to="/admin/users"
                    onClick={closeMenu}
                  >
                    <i className="fas fa-users-cog mr-2 text-[#D4AF37]"></i>{" "}
                    Utilisateurs
                  </Link>

                  {/* Gestion des Rôles */}
                  <Link
                    className="text-xs py-2 font-bold block text-white hover:text-slate-300 transition-colors"
                    to="/admin/roles"
                    onClick={closeMenu}
                  >
                    <i className="fas fa-user-shield mr-2 text-[#D4AF37]"></i>{" "}
                    Rôles
                  </Link>

                  {/* Gestion des Permissions */}
                  <Link
                    className="text-xs py-2 font-bold block text-white hover:text-slate-300 transition-colors"
                    to="/admin/permissions"
                    onClick={closeMenu}
                  >
                    <i className="fas fa-key mr-2 text-[#D4AF37]"></i>{" "}
                    Permissions
                  </Link>

                  {/* AJOUT : Gestion des Caisses / Fonds */}
                  <Link
                    className={
                      "text-xs py-2 font-bold block transition-colors " +
                      (window.location.pathname.includes("/admin/funds")
                        ? "text-[#D4AF37]"
                        : "text-white hover:text-slate-300")
                    }
                    to="/admin/funds"
                    onClick={closeMenu}
                  >
                    <i className="fas fa-coins mr-2 text-[#D4AF37]"></i> Caisses
                  </Link>

                  {/* AJOUT : Permissions de Ressources */}
                  <Link
                    className={
                      "text-xs py-2 font-bold block transition-colors " +
                      (window.location.pathname.includes(
                        "/admin/resource-permissions",
                      )
                        ? "text-[#D4AF37]"
                        : "text-white hover:text-slate-300")
                    }
                    to="/admin/resource-permissions"
                    onClick={closeMenu}
                  >
                    <i className="fas fa-user-lock mr-2 text-[#D4AF37]"></i>{" "}
                    Droits d'accès ressources
                  </Link>

                  {/* AJOUT : Pistes d'Audit */}
                  <Link
                    className={
                      "text-xs py-2 font-bold block transition-colors " +
                      (window.location.pathname.includes("/admin/audit-logs")
                        ? "text-[#D4AF37]"
                        : "text-white hover:text-slate-300")
                    }
                    to="/admin/audit-logs"
                    onClick={closeMenu}
                  >
                    <i className="fas fa-history mr-2 text-[#D4AF37]"></i>{" "}
                    Pistes d'audit
                  </Link>
                </li>
              )}
            </ul>
          </div>
        </div>
      </nav>
    </>
  );
}
